import { DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutShipmentStatusErrors extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelAsset: Label;
    labelAssetOnlyDesc: Label;
    labelAssetOnlyTotal: Label;
    labelAvailable: Label;
    labelAvailableCount: Label;
    labelBrokerage: Label;
    labelCovered: Label;
    labelCoveredAmount: Label;
    labelDelivered: Label;
    labelDeliveredCount: Label;
    labelInProgress: Label;
    labelInProgressAmount: Label;
    labelTotal: Label;
    labelTotalCount: Label;
    labelTotalCountOrder: Label;
    labelTotalOrder: Label;
    panelAssetOnly: Panel;
    panelAssetOnlyDesc: Panel;
    panelBrokerageAvailable: Panel;
    panelCovered: Panel;
    panelDelivered: Panel;
    panelInProgress: Panel;
    panelTotalBrokerage: Panel;
    panelTotalOrders: Panel;
    sourceShipmentStatusErrors: DataSource;
}
